export const TypeOperator = {
    DEFAULT: "EQ",
    ENTRE: "BT",
    CONTEM: "LK",
    NAO_CONTEM: "NLK",
    MAIOR_QUE: "GT",
    MAIOR_OU_IGUAL_QUE: "GE",
    MENOR_OU_IGUAL_QUE: "LE",
    MENOR_QUE: "LT",
    IGUAL: "EQ",
    DIFERENTE: "DF",
    TODOS: "LK",
};